import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormlyModule } from '@ngx-formly/core'
import { ReactiveFormsModule } from '@angular/forms'

import { SatinelSelectModule } from '@satinel-system/core'

import { PatientFieldComponent } from './patient-field.component'

@NgModule({
  declarations: [PatientFieldComponent],
  imports: [
    FormlyModule,
    CommonModule,
    ReactiveFormsModule,
    SatinelSelectModule
  ],
  exports: [PatientFieldComponent]
})
export class PatientFieldModule {}
